import React, { useMemo } from "react";

import * as SC from "./AssetsUpload.styled";
import PlusCircle from "../../../../../Components/PlusCircle";
import { getCompanyImageFolderName } from "../../../../../utils/GetCompanyFolderName";
import useCloudinaryUpload from "../../../../../hooks/useCloudinaryUpload";
import LoadingIndicator from "react-loading-indicator";
import { IconCheck } from "../../../../../Components/Icons";

const AssetsUpload = ({
  isLogo,
  src = [],
  selectedAsset = "",
  campaignData,
  handleLogoSelection,
  handleNewImageUpload,
  isLoading
}) => {
  const { emitCloudinaryUpload, uploading } = useCloudinaryUpload();

  const validSrc = Array.isArray(src)
    ? src.filter((item) => typeof item === "string" && item.trim() !== "")
    : [];

  const { organizationId, companyId, orgaName, companyName } = campaignData;
  const { folderName } = useMemo(
    () =>
      getCompanyImageFolderName({
        orgaId: organizationId,
        companyId,
        orgaName,
        companyName
      }),
    [organizationId, companyId, orgaName, companyName]
  );

  // Cloudinary metadata
  const cloudinaryContext = useMemo(() => {
    const { organizationId: orgaId, id: campaignId } = campaignData || {};

    let context = `orgaId=${orgaId}|source=template-media-library`;

    if (campaignId) {
      context += `|campaignId=${campaignId}`;
    }

    return context;
  }, [campaignData.orgaName, campaignData.id]);

  // Cloudinary upload
  const emitUpload = (event) => {
    emitCloudinaryUpload(event, {
      image: "",
      handlePictureChanged: (data) => handleNewImageUpload(data?.url),
      allowVideos: false,
      allowImages: true,
      fileTypes: [],
      context: cloudinaryContext,
      folderName,
      isLogo,
      type: "Upload"
    });
  };

  return (
    <SC.AssetsUploadWrapper>
      {validSrc.length > 0 &&
        !isLoading &&
        validSrc.map((src, index) => {
          const isFileSelected = selectedAsset === src;

          return (
            <SC.AssetWrapper key={index} onClick={() => handleLogoSelection(src)}>
              <SC.Asset isLogo={isLogo} src={src} />
              {isFileSelected && (
                <SC.IconWrapper>
                  <IconCheck />
                </SC.IconWrapper>
              )}
            </SC.AssetWrapper>
          );
        })}

      <SC.EmptyAsset isLogo={isLogo}>
        {isLoading ? (
          <LoadingIndicator />
        ) : (
          <>
            <input
              disabled={uploading}
              id={"upload-btn-campaign-creation-media-assets"}
              type="file"
              onChange={emitUpload}
              style={{ display: "none" }}
            />
            <SC.UploadAssetButton htmlFor={"upload-btn-campaign-creation-media-assets"}>
              {uploading ? <LoadingIndicator /> : <PlusCircle />}
            </SC.UploadAssetButton>
          </>
        )}
      </SC.EmptyAsset>
    </SC.AssetsUploadWrapper>
  );
};

export default AssetsUpload;
